import { render, staticRenderFns } from "./ModelIncome.vue?vue&type=template&id=c158aba4&scoped=true"
import script from "./ModelIncome.vue?vue&type=script&lang=js"
export * from "./ModelIncome.vue?vue&type=script&lang=js"
import style0 from "./ModelIncome.vue?vue&type=style&index=0&id=c158aba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c158aba4",
  null
  
)

export default component.exports